import { useEffect, useState } from "react";
import "./SelectWallet.scss";
import { useConnectWallet } from "@web3-onboard/react";
import { Web3 } from "web3";
import FormData from "form-data";
import axios, { AxiosResponse } from "axios";
import Loading from "./components/Loading";
import { useLocation } from "react-router-dom";

const SelectWallet = () => {
  // eslint-disable-next-line no-empty-pattern
  const [{ wallet }, connect] = useConnectWallet();
  const [, setError] = useState();
  const [isSigning, setIsSigning] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const signMessage = async () => {
      const web3 = new Web3(wallet?.provider);

      const accounts = await web3.eth.getAccounts();

      const tokenData = await initLogin();
      if (!tokenData) {
        throw new Error("TokenData is missing!");
      }

      const from = accounts[0];
      const sign = await web3.eth.personal.sign(web3.utils.utf8ToHex(tokenData.tokenMessage), from, "");

      const form = new FormData();
      form.append("SignedLoginMessage", sign);
      form.append("WalletAddress", from);
      form.append("Token", tokenData.token);

      let response: AxiosResponse;
      if (location.pathname.includes("/register")) {
        response = await axios.post("/do-register-with-wallet", form);
      } else {
        response = await axios.post("/do-login-with-wallet", form);
      }

      if (response.data?.redirectUrl) {
        window.location = response.data.redirectUrl;
      }
    };

    const initLogin = async () => {
      const response = await axios.get("/start-login-with-wallet");
      if (response.status === 200) {
        const resp = response.data;

        if (resp.code === "OK" && resp.data !== null) {
          return resp.data;
        }
      }
      return null;
    };

    const handleError = (e: any) => {
      setError(() => {
        // rethrow the error inside a hook this will load the error boundry
        throw new Error(`Wallet login failed! Error: ${e}`);
      });
    };

    if (wallet?.label) {
      setIsSigning(true);
      signMessage().catch(handleError);
    }
  }, [wallet?.label, wallet?.provider, location.pathname]);

  return (
    <>
      <div id="WalletSelectingBlock" className="text-center">
        <div className="checkout-walletselector-items mt-50">
          <h3>Connect Wallet</h3>

          {isSigning && <Loading title="Signing message..."></Loading>}

          {!isSigning && (
            <>
              <p>Start by connecting with your wallet. Be sure to store your private keys or seed phrase securely. Never share them with anyone.</p>
              <button
                className="btn btn-primary"
                onClick={async () => {
                  await connect();
                }}
              >
                Connect your wallet
              </button>
            </>
          )}
        </div>
        <div className="checkout-walletselector-help-container">
          <h3>Haven't got a wallet yet?</h3>
          <a href={(window as any).siteRootUrl + "/help"} target="_blank" rel="noopener noreferrer">
            {"Go to Help "}
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.375 0C8.85645 0 8.4375 0.418945 8.4375 0.9375C8.4375 1.45605 8.85645 1.875 9.375 1.875H11.7979L5.90039 7.77539C5.53418 8.1416 5.53418 8.73633 5.90039 9.10254C6.2666 9.46875 6.86133 9.46875 7.22754 9.10254L13.125 3.20215V5.625C13.125 6.14355 13.5439 6.5625 14.0625 6.5625C14.5811 6.5625 15 6.14355 15 5.625V0.9375C15 0.418945 14.5811 0 14.0625 0H9.375ZM2.34375 0.9375C1.04883 0.9375 0 1.98633 0 3.28125V12.6562C0 13.9512 1.04883 15 2.34375 15H11.7188C13.0137 15 14.0625 13.9512 14.0625 12.6562V9.375C14.0625 8.85645 13.6436 8.4375 13.125 8.4375C12.6064 8.4375 12.1875 8.85645 12.1875 9.375V12.6562C12.1875 12.9141 11.9766 13.125 11.7188 13.125H2.34375C2.08594 13.125 1.875 12.9141 1.875 12.6562V3.28125C1.875 3.02344 2.08594 2.8125 2.34375 2.8125H5.625C6.14355 2.8125 6.5625 2.39355 6.5625 1.875C6.5625 1.35645 6.14355 0.9375 5.625 0.9375H2.34375Z"
                fill="#508699"
              />
            </svg>
          </a>
        </div>
      </div>
    </>
  );
};

export default SelectWallet;
